import { useState } from 'react';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleLogoClick = () => {
    if (window.location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/';
    }
  };

  return (
    <nav className="absolute top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={handleLogoClick}>
            <img 
              src="https://static.readdy.ai/image/f188085399ab07ac2c79984c802b33af/d7137dec17d438e55dac1175e416585f.png" 
              alt="ReceptionGenie Logo" 
              className="w-12 h-12"
            />
            <span className="text-2xl font-bold text-gray-900 hover:text-pink-600 transition-colors" style={{ fontFamily: "'Pacifico', serif" }}>
              ReceptionGenie.ai
            </span>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-pink-600 font-medium transition-colors cursor-pointer whitespace-nowrap">
              Features
            </button>
            <a href="/how-it-works" className="text-gray-700 hover:text-pink-600 font-medium transition-colors cursor-pointer whitespace-nowrap">
              How It Works
            </a>
            <a href="/demo-call" className="text-gray-700 hover:text-pink-600 font-medium transition-colors cursor-pointer whitespace-nowrap">
              Demo Call
            </a>
            <a href="/lost-revenue-calculator" className="text-gray-700 hover:text-pink-600 font-medium transition-colors cursor-pointer whitespace-nowrap">
              Lost Revenue Calculator
            </a>
            <a href="/payment" className="text-gray-700 hover:text-pink-600 font-medium transition-colors cursor-pointer whitespace-nowrap">
              Pricing
            </a>
            <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-pink-600 font-medium transition-colors cursor-pointer whitespace-nowrap">
              FAQ
            </button>
            <a href="/blog" className="text-gray-700 hover:text-pink-600 font-medium transition-colors cursor-pointer whitespace-nowrap">
              Blog
            </a>
            <a 
              href="/demo-call"
              className="whitespace-nowrap px-6 py-2.5 bg-pink-500 hover:bg-pink-600 text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer"
            >
              Listen to Live Demo
            </a>
          </div>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-4">
            <button onClick={() => scrollToSection('features')} className="block w-full text-left text-gray-700 hover:text-pink-600 font-medium py-2 cursor-pointer">
              Features
            </button>
            <a href="/how-it-works" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-pink-600 font-medium py-2 cursor-pointer">
              How It Works
            </a>
            <a href="/demo-call" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-pink-600 font-medium py-2 cursor-pointer">
              Demo Call
            </a>
            <a href="/lost-revenue-calculator" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-pink-600 font-medium py-2 cursor-pointer">
              Lost Revenue Calculator
            </a>
            <a href="/payment" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-pink-600 font-medium py-2 cursor-pointer">
              Pricing
            </a>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left text-gray-700 hover:text-pink-600 font-medium py-2 cursor-pointer">
              FAQ
            </button>
            <a href="/blog" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-pink-600 font-medium py-2 cursor-pointer">
              Blog
            </a>
            <a 
              href="/demo-call"
              onClick={() => setMobileMenuOpen(false)}
              className="whitespace-nowrap w-full px-6 py-2.5 bg-pink-500 hover:bg-pink-600 text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer text-center block"
            >
              Try the Live Demo
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
